import {
    LOGIN_ACTION,
    LOGOUT_ACTION,
    VALIDATE_LOGIN_ACTION,
    REFRESH_TOKEN_ACTION,
    SAVE_USER_INFO_ACTION,
} from '../action-types/auth';

export const loginAction = ({ userId, username, token, authenticated = true }) => ({
    type: LOGIN_ACTION,
    userId,
    username,
    token,
    authenticated,
});

export const validateLoginAction = () => ({
    type: VALIDATE_LOGIN_ACTION,
});

export const logoutAction = () => ({
    type: LOGOUT_ACTION,
});

export const refreshTokenAction = token => ({
    type: REFRESH_TOKEN_ACTION,
    token,
});

export const saveUserInfoAction = userInfo => ({
    type: SAVE_USER_INFO_ACTION,
    userInfo,
});



// WEBPACK FOOTER //
// ./src/common/action-creators/auth.js